/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { TestPaneSeparator } from 'src/luis/projects/testPane/components/common/TestPaneSeparator';

/**
 * Represents the action links segment in the blade titles.
 */
export const TestBladeActionBar: React.FunctionComponent<{ children?: React.ReactNode }> = props => (
    <Stack horizontalAlign="stretch">
        <Stack.Item>{props.children}</Stack.Item>

        <TestPaneSeparator separatorType="headerSeparator" />
    </Stack>
);
